import { useContext, useEffect } from "react"
import { CancelButton, CommandButton, Loading } from "components"
import { ActionButton } from "../components"
import { InputSection, ModalAttachmentPaymentBillService } from "./components"
import { AccountProvider } from "contexts"
import { BillContext } from "./contexts"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import moment from "moment"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import { convertNumber, useApi } from "utils"
import { PaymentBillServiceSchema, paymentBillServiceSchema } from "./schema"
import { useGetSingleBillService } from "../BillService/hooks"

export const CreatePaymentBillService = () => {
  const api = useApi()
  const { id } = useParams()
  const navigate = useNavigate()
  const trxCode = localStorage.getItem("trx_code_payment_bill")

  const detailBill = useGetSingleBillService(id!)
  const data = useContext(BillContext)

  const databill = data.databill
  const balance: number = databill.balance
  const saldo_deposit: number = databill.saldo_deposit
  const deposit_amount: number = saldo_deposit < 0 ? 0 : saldo_deposit > balance ? balance : saldo_deposit

  const freight = parseFloat(detailBill?.data?.freight ?? "0");
  const subtotal = detailBill?.data?.detail_bill?.reduce((acc, item) => acc + parseFloat(item?.total ?? 0) + parseFloat(item?.total_tax_paid ?? 0), 0);
  const resultBalance = freight + (subtotal ?? 0);

  const defaultValues: PaymentBillServiceSchema = {
    deposit_amount,
    _balance: 0,
    coa_id: "",
    memo: "Payment bill service transaction",
    payment_amount: 0,
    referensi: "",
    trx_code: "",
    transaction_date: moment().format("YYYY-MM-DD"),
    vendor_id: databill.vendor_id,
    imgPath: []
  }
  const methods = useForm<PaymentBillServiceSchema>({ defaultValues, resolver: yupResolver(paymentBillServiceSchema) })

  useEffect(() => {
    if (detailBill?.data) {
      methods.setValue("vendor_id", String(detailBill.data.vendor_id))
    }
    // eslint-disable-next-line
  }, [detailBill?.data])

  const onSubmit = (value: PaymentBillServiceSchema) => {
    const final_value = {
      bill_id: detailBill?.data?.bill_id,
      trx_code: value.trx_code,
      vendor_id: String(detailBill?.data?.vendor_id),
      location_id: String(detailBill?.data?.location_id),
      address: detailBill?.data?.address,
      memo: value.memo,
      transaction_date: value.transaction_date,
      referensi: value.referensi,
      coa_id: value.coa_id,
      deposit_amount: value.deposit_amount,
      payment_amount: value.payment_amount,
      imgPath: value.imgPath || []
    }
    const isBelowBalance: boolean = (resultBalance ?? 0) - value.deposit_amount - value.payment_amount < 0

    return new Promise<void>((resolve) => {
      const submitForm = (): void => {
        toast.promise(api.post("/paymentbill/add_payment_bill_service", final_value), {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.detail?.message ?? err.response.data.message
        })
        .then(() => navigate(`/purchase/transaction/bill-service/${detailBill?.data?.bill_id}`))
        .catch(() => {})
        .finally(resolve)
      }

      if (!value.payment_amount || value.payment_amount <= 0) {
        toast.error("Payment Amount must be greater than 0")
        return resolve()
      } else if(value.payment_amount > value._balance) {
        toast.error("Payment Amount cannot be more than Balance Bill Service")
        return resolve() 
      } else if (isBelowBalance) {
        toast.error("Payment Deposit & Payment Amount cannot be more than Balance Bill")
        return resolve()
      } else if (value.deposit_amount > saldo_deposit) {
        toast.error(`Payment Deposit cannot be more than The Deposit Balance (Current balance: ${convertNumber(saldo_deposit).intoNormalAmount})`)
        return resolve()
      }

      submitForm()
    })
  }

  return (
    <BillContext.Provider
      value={{
        approve_by: Number(detailBill?.data?.approve_by) ?? null,
        approve_status: Number(detailBill?.data?.approval_status) ?? 0,
        bill_id: Number(detailBill?.data?.bill_id) ?? 0,
        coa_id: "",
        deposit_amount: 0,
        memo: detailBill?.data?.memo ?? "",
        payment_amount: 0,
        purchase_order_id: 0,
        referensi: detailBill?.data?.referensi ?? "",
        transaction_date: detailBill?.data?.transaction_date ?? "",
        trx_code: detailBill?.data?.trx_code ?? "",
        databill: {
          address: detailBill?.data?.address ?? "",
          balance: resultBalance ?? 0,
          location_id: String(detailBill?.data?.location_id) ?? "",
          saldo_deposit: 0,
          trx_code: detailBill?.data?.trx_code ?? "",
          vendor_id: String(detailBill?.data?.vendor_id) ?? "",
          vendor_name: detailBill?.data?.vendor_name ?? ""
        }
      }}
    >
      <AccountProvider>
        {detailBill.isLoading || !detailBill?.data ? (<Loading loading={detailBill.isLoading} />) : (
          <FormProvider {...methods}>
            <InputSection
              buttonsection={
                <ActionButton>
                  <section className="flex flex-wrap gap-3">
                    {/* <CommandButton actiontype="print" onClick={toggle} /> */}
                    <ModalAttachmentPaymentBillService code={trxCode!} />

                    {/* {isActive ? (<PrintPaymentBillServiceCreate toggle={toggle} />) : null} */}
                  </section>

                  <section className="flex flex-wrap gap-3">
                    <CancelButton />

                    <CommandButton
                      actiontype="save"
                      loading={methods.formState.isSubmitting ? "true" : undefined}
                      onClick={methods.handleSubmit(onSubmit)}
                    />
                  </section>
                </ActionButton>
              }
            />
          </FormProvider>
        )}
      </AccountProvider>
    </BillContext.Provider>
  )
}
